import ProjectState from "src/Types/states/ProjectState";

const projectInitialState:ProjectState = [];

export default projectInitialState;
